import GreaterThanInterface from './GreaterThanInterface';

export default class GreaterThan implements GreaterThanInterface
{
  validate(valueToCompare: number, secondValue: string): boolean {
    return valueToCompare < parseInt(secondValue)
  }
}
